/**
 * Нижняя панель: логотип 3CupsGames, название игры, дата/время
 */

import * as PIXI from 'pixi.js';
import { TextStyle } from 'pixi.js';
import { COLORS } from '@/config/colors';

export class Footer extends PIXI.Container {
  private logoText: PIXI.Text;
  private gameTitle: PIXI.Text;
  private dateTimeText: PIXI.Text;
  private updateInterval: number | null = null;

  constructor() {
    super();
    this.logoText = new PIXI.Text(
      '3CupsGames',
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 20,
        fill: COLORS.purple,
        fontWeight: 'bold',
      })
    );
    this.logoText.anchor.set(0, 0.5);
    this.logoText.x = 20;
    this.logoText.y = 0;
    this.addChild(this.logoText);

    this.gameTitle = new PIXI.Text(
      'Nexus',
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 14,
        fill: COLORS.textSecondary,
      })
    );
    this.gameTitle.anchor.set(0, 0.5);
    this.gameTitle.x = this.logoText.x + this.logoText.width + 10;
    this.gameTitle.y = 0;
    this.addChild(this.gameTitle);

    this.dateTimeText = new PIXI.Text(
      this.getDateTimeString(),
      new TextStyle({
        fontFamily: '"Jost"',
        fontSize: 12,
        fill: COLORS.textSecondary,
      })
    );
    this.dateTimeText.anchor.set(1, 0.5);
    this.dateTimeText.y = 0;
    this.addChild(this.dateTimeText);

    this.startDateTimeUpdate();
  }

  private getDateTimeString(): string {
    const now = new Date();
    const day = now.getDate();
    const month = now.toLocaleString('en', { month: 'short' });
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${day} ${month}, ${year} | ${hours}:${minutes}:${seconds}`;
  }

  private startDateTimeUpdate(): void {
    this.updateDateTime();
    this.updateInterval = window.setInterval(() => {
      this.updateDateTime();
    }, 1000);
  }

  private updateDateTime(): void {
    this.dateTimeText.text = this.getDateTimeString();
  }

  resize(width: number): void {
    this.dateTimeText.x = width - 20;
  }

  destroy(): void {
    if (this.updateInterval !== null) {
      clearInterval(this.updateInterval);
    }
    super.destroy();
  }
}
